import { render, staticRenderFns } from "./dividedIntoInformations.vue?vue&type=template&id=6c80070b&scoped=true"
import script from "./dividedIntoInformations.vue?vue&type=script&lang=js"
export * from "./dividedIntoInformations.vue?vue&type=script&lang=js"
import style0 from "./dividedIntoInformations.vue?vue&type=style&index=0&id=6c80070b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80070b",
  null
  
)

export default component.exports